<template>
    <div
        class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center gap-2 md:gap-8 lg:max-w-(--breakpoint-sm)"
    >
        <vx-expandable-card>
            <template v-slot:content>
                <div class="font-extrabold text-base mb-2 flex items-center justify-between">
                    <span>Details</span>
                    <router-button
                        v-if="allowEditContact"
                        :to="{ name: 'contacts.edit', params: { contactId: props.contactId } }"
                        outline
                        color="muted"
                    >
                        Edit <font-awesome-icon widthAuto :icon="faPen"></font-awesome-icon>
                    </router-button>
                </div>
                <contact-view-content
                    @currentGroupRemoved="emit('currentGroupRemoved')"
                    :allowEditContact="props.allowEditContact"
                    :editableRelationships="props.editableRelationships"
                ></contact-view-content>
            </template>
        </vx-expandable-card>
        <contact-attribute-sets-panel
            v-if="FEATURES.local_attributes"
            :editableAttributes="props.editableRelationships"
        ></contact-attribute-sets-panel>
    </div>
</template>

<script setup>
import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxExpandableCard } from '@voxie/frontend-components';
import { inject } from 'vue';
import ContactAttributeSetsPanel from '~/components/contacts/contact/ContactAttributeSetsPanel.vue';
import ContactViewContent from '~/components/contacts/contact/view/ContactViewContent.vue';
import RouterButton from '~/components/general/RouterButton.vue';

const FEATURES = inject('FEATURES');

const props = defineProps({
    contactId: {
        type: Number,
        required: false,
    },
    allowEditContact: {
        type: Boolean,
        default: true,
    },
    editableRelationships: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['currentGroupRemoved']);
</script>
